// extracted by mini-css-extract-plugin
export default {"link":"gE-z","disabled":"hE-z"};